// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html"
// Establish Phoenix Socket and LiveView configuration.
import {Socket} from "phoenix"
import {LiveSocket} from "phoenix_live_view"
import topbar from "../vendor/topbar"
// Import Trix editor
import "trix"

// Trix Editor Hook
const TrixEditor = {
  mounted() {
    this.setupTrix()
  },

  setupTrix() {
    const trixEditor = this.el.querySelector('trix-editor')
    const hiddenInput = this.el.querySelector('input[type="hidden"]')
    
    if (!trixEditor || !hiddenInput) return

    // Disable file attachments since we don't want uploads
    trixEditor.addEventListener('trix-attachment-add', (event) => {
      event.attachment.remove()
    })

    // Sync Trix content with hidden input for form submission
    trixEditor.addEventListener('trix-change', (event) => {
      hiddenInput.value = trixEditor.innerHTML
    })

    // Handle form submission to ensure content is synced
    const form = trixEditor.closest('form')
    if (form) {
      form.addEventListener('submit', () => {
        if (trixEditor && trixEditor.editor && hiddenInput) {
          hiddenInput.value = trixEditor.innerHTML
        }
      })
    }

    // Set initial content if present
    if (hiddenInput.value) {
      // Wait for Trix to fully initialize
      if (trixEditor.editor) {
        trixEditor.editor.loadHTML(hiddenInput.value)
      } else {
        trixEditor.addEventListener('trix-initialize', () => {
          trixEditor.editor.loadHTML(hiddenInput.value)
        }, { once: true })
      }
    }
  }
}

let Hooks = {
  TrixEditor: TrixEditor
}

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: 2500,
  params: {_csrf_token: csrfToken},
  hooks: Hooks
})

// Show progress bar on live navigation and form submits
topbar.config({barColors: {0: "#29d"}, shadowColor: "rgba(0, 0, 0, .3)"})
window.addEventListener("phx:page-loading-start", _info => topbar.show(300))
window.addEventListener("phx:page-loading-stop", _info => topbar.hide())

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket

// Modern website interactions
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  const mobileMenuButton = document.getElementById('mobile-menu-button')
  const mobileMenu = document.getElementById('mobile-menu')
  
  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', function() {
      const isHidden = mobileMenu.classList.contains('hidden')
      
      if (isHidden) {
        mobileMenu.classList.remove('hidden')
        mobileMenu.style.opacity = '0'
        mobileMenu.style.transform = 'translateY(-10px)'
        
        // Animate in
        requestAnimationFrame(() => {
          mobileMenu.style.transition = 'all 0.2s ease-out'
          mobileMenu.style.opacity = '1'
          mobileMenu.style.transform = 'translateY(0)'
        })
      } else {
        mobileMenu.style.transition = 'all 0.2s ease-in'
        mobileMenu.style.opacity = '0'
        mobileMenu.style.transform = 'translateY(-10px)'
        
        setTimeout(() => {
          mobileMenu.classList.add('hidden')
        }, 200)
      }
    })
    
    // Close mobile menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!mobileMenu.contains(e.target) && !mobileMenuButton.contains(e.target)) {
        if (!mobileMenu.classList.contains('hidden')) {
          mobileMenu.style.transition = 'all 0.2s ease-in'
          mobileMenu.style.opacity = '0'
          mobileMenu.style.transform = 'translateY(-10px)'
          
          setTimeout(() => {
            mobileMenu.classList.add('hidden')
          }, 200)
        }
      }
    })
  }
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'))
      if (target) {
        e.preventDefault()
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    })
  })
  
  // Add loading states for buttons
  document.querySelectorAll('.btn-primary, .btn-secondary').forEach(button => {
    button.addEventListener('click', function(e) {
      // Don't add loading state for external links
      if (this.getAttribute('href') && this.getAttribute('href').startsWith('http')) {
        return
      }
      
      // Add loading state
      const originalContent = this.innerHTML
      this.innerHTML = `
        <svg class="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Loading...
      `
      this.disabled = true
      
      // Reset after navigation (if it's not external)
      setTimeout(() => {
        this.innerHTML = originalContent
        this.disabled = false
      }, 2000)
    })
  })
  
  // Progressive image loading
  const images = document.querySelectorAll('img[data-src]')
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target
        img.src = img.dataset.src
        img.classList.remove('lazy')
        imageObserver.unobserve(img)
      }
    })
  })
  
  images.forEach(img => {
    imageObserver.observe(img)
  })
})

